import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ScheduleQuestionAndOptions, ScheduleQuestionProp } from 'src/app/models/Exam';
import { LanguageService } from 'src/app/services/language.service';

@Component({
  selector: 'app-unanswered-questions-modal',
  templateUrl: './unanswered-questions-modal.component.html',
  styleUrls: ['./unanswered-questions-modal.component.css']
})
export class UnansweredQuestionsModalComponent {
  @Input() questions: ScheduleQuestionAndOptions[] = [];

  constructor(public activeModal: NgbActiveModal, public languageService: LanguageService,) {}

  get language() {
    return this.languageService.language;
  }
  
  goToQuestion(questionno: number) {
    this.activeModal.close(questionno);
  }

  closeModal() {
    this.activeModal.dismiss();
  }
}
